import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InteractionQueueConfigService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getCustomInteractionQueueConfigList(filter) {
    return this.http.post<any>('api/interactionQueueConfig/getCustomInteractionQueueConfigList', filter);
  }

  deleteCustomInteractionQueueConfig(queue) {
    return this.http.post<any>('api/interactionQueueConfig/deleteCustomInteractionQueueConfig', queue);
  }

  cloneCustomInteractionQueueConfig(configId) {
    return this.http.post<number>('api/interactionQueueConfig/cloneCustomInteractionQueueConfig', configId);
  }

  getOverflowCustomIntQueues(configId) {
    return this.http.post<any[]>('api/interactionQueueConfig/getOverflowCustomIntQueues', configId);
  }

  getAllCustomIntQueueMetadataValues(configId) {
    return this.http.post<any[]>('api/interactionQueueConfig/getAllCustomIntQueueMetadataValues', configId);
  }

  updateInteractionQueueConfig(config) {
    return this.http.post<void>('api/interactionQueueConfig/updateInteractionQueueConfig', config);
  }

  createInteractionQueueConfig(config) {
    return this.http.post<number>('api/interactionQueueConfig/createInteractionQueueConfig', config);
  }
 }
